import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {useIntl} from 'react-intl';

import {Button, Descriptions, Tag} from 'antd';
import {ServiceRequestStatus} from 'shared/constants/AppConst';
import {RequestContext} from '../RequestContext';
import RequestEditor from '../RequestEditor';
import {periodTimeText} from 'utils/Utils';

const RequestInfo = () => {
  const intl = useIntl();

  const requestContext = useContext(RequestContext);
  const {selectedRequest, setEditing} = requestContext;

  const onEdit = () => {
    setEditing(true);
  };

  return (
    <>
      <Descriptions
        bordered
        title={selectedRequest?.patient?.name}
        size='middle'
        style={{paddingTop: 10}}
        extra={
          (selectedRequest?.status === ServiceRequestStatus.draft ||
            selectedRequest?.status === ServiceRequestStatus.active) && (
            <Button type='primary' onClick={() => onEdit()}>
              {intl.messages['common.edit']}
            </Button>
          )
        }>
        <Descriptions.Item label={intl.messages['request.requester']}>
          {selectedRequest?.requester && (
            <Tag color='green'>
              <Link
                to={`/health/practitioners/${selectedRequest.requester.id}`}>
                {selectedRequest.requester.name}
              </Link>
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.performer']}>
          {selectedRequest?.performer && (
            <Tag color='green'>
              <Link
                to={`/health/practitioners/${selectedRequest.performer.id}`}>
                {selectedRequest.performer.name}
              </Link>
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.speciality']} span={2}>
          {selectedRequest?.speciality?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.status']}>
          <Tag color='red'>
            {
              intl.messages[
                `request.status.${selectedRequest?.status.toLowerCase()}`
              ]
            }
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.symptom']} span={3}>
          {selectedRequest?.symptom}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.note']} span={3}>
          {selectedRequest?.note}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.messages['request.instruction']}
          span={3}>
          {selectedRequest?.instruction}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.occurrenceDate']}>
          {periodTimeText(
            selectedRequest?.occurrenceStartTime,
            selectedRequest?.occurrenceEndTime,
          )}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.messages['request.performanceDate']}
          span={2}>
          {periodTimeText(
            selectedRequest?.performanceStartTime,
            selectedRequest?.performanceEndTime,
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['request.location']}>
          {selectedRequest?.location ? (
            <Link to={`/health/locations/${selectedRequest.location.id}`}>
              {selectedRequest.location.name}
            </Link>
          ) : (
            ''
          )}
        </Descriptions.Item>
      </Descriptions>

      <RequestEditor />
    </>
  );
};

export default RequestInfo;
